export default {
  valueType: "radio",
  FormItemProps: {
    label: '单选框',
    rules: [],
    style: {}
  },
  ControlProps: {
    options: [
      { label: "选项一", value: "1" },
      { label: "选项二", value: "2" }
    ],
  },
}

